import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative h-screen overflow-hidden" }
const _hoisted_2 = { class: "flex flex-1 flex-col gap-4 overflow-auto px-4 py-2 pb-6 md:px-8 md:py-4 md:pb-12" }

import NavBar from '@/components/layouts/NavBar.vue'
import { useNavBarStore } from '@/stores/NavBarStore'
import { onMounted, ref } from 'vue'
import { RouterView } from 'vue-router'

import SystemWarnings from './SystemWarnings.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Default',
  setup(__props) {

const navBar = useNavBarStore()

let warningShownThisSession = false
const showWarning = ref(false)

onMounted(() => {
  if (warningShownThisSession) return
  const dismissed = localStorage.getItem('warningDismissed')
  if (dismissed !== 'true') {
    showWarning.value = true
    warningShownThisSession = true
  }
})
function handleDismiss() {
  localStorage.setItem('warningDismissed', 'true')
  showWarning.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavBar),
    _createElementVNode("div", {
      class: _normalizeClass(['ml-20 flex h-full flex-col transition-all duration-300', { 'ml-80': _unref(navBar).shown }])
    }, [
      _createElementVNode("main", _hoisted_2, [
        _createVNode(_unref(RouterView))
      ])
    ], 2)
  ]))
}
}

})